import { render, staticRenderFns } from "./EMailForm.vue?vue&type=template&id=620a9452&scoped=true&"
import script from "./EMailForm.vue?vue&type=script&lang=js&"
export * from "./EMailForm.vue?vue&type=script&lang=js&"
import style0 from "./EMailForm.vue?vue&type=style&index=0&id=620a9452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a9452",
  null
  
)

export default component.exports